export default "__VITE_ASSET__0le3HRip__"